import Controller from '../abstracts/Controller';

export default class RegisterController extends Controller {
  static get COMPONENTS() {
    return ['RecaptchaComponent', 'VerifyRegisterBySmsComponent','PasswordHelperComponent', 'RegistrationComponent'];
  }
}
